"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statusCodes = Object.freeze([{
  code: 0,
  description: "Select A Reason"
},
// pass --------------------------------------------------
{
  code: 101,
  description: "Satisfactory"
},
// warn --------------------------------------------------
{
  code: 201,
  description: "Potential Issue"
}, {
  code: 202,
  description: "Troubleshooting needed"
}, {
  code: 203,
  description: "Follow up required"
},
// fail --------------------------------------------------
{
  code: 301,
  description: "Out of Threshold"
}, {
  code: 302,
  description: "Unplanned event occurred"
}, {
  code: 303,
  description: "Asset Inoperable/broken"
}, {
  code: 304,
  description: "Other Major Issue"
},
// skip --------------------------------------------------
{
  code: 401,
  description: "Asset Obstructed"
}, {
  code: 402,
  description: "Unable to Complete"
}, {
  code: 403,
  description: "Asset not Found"
}]);
var _default = exports.default = statusCodes;